"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.defaultCacheUrls = void 0;
var vue_router_1 = __importDefault(require("vue-router"));
var config_1 = require("./config");
__createBinding(exports, config_1, "defaultCacheUrls");
__exportStar(require("./utils"), exports);
var _a = (vue_router_1["default"] || {}).version, version = _a === void 0 ? '4.0.0' : _a;
var majorVersion = version.split('.').map(Number)[0];
var getRouter = majorVersion === 4
    ? require('./get-router-4')["default"]
    : require('./get-router-3')["default"];
exports["default"] = getRouter;
//# sourceMappingURL=index.js.map